<template>
	<div v-if="bannerData" class="w-full !py-2 bg-black flex justify-center items-center">
		<p class="!m-0 !p-0 w-fit text-xs/[18px] max-w-[390px] md:max-w-none font-normal text-white text-center">
			<span class="pe-2">{{ message }}</span>
			<hero-banner-modal
				ref="heroModal"
				v-if="hasModal && id === 'brush_blitz_2025'"
				:auto-show="autoShow"
				:id="id"
				btn-class="text-white text-xs/[18px] underline underline-offset-2"
				:show-btn="true"
				:btn-text="cta"
			>
				<template v-slot:content-left>
					<div class="flex flex-col gap-4 justify-center h-full md:max-h-[360px] !py-4.5">
						<h3 class="text-center !m-0 !p-0 font-butler-light text-lg font-light uppercase">
							Because One Brush Is Never Enough...
						</h3>
						<p class="font-normal text-center text-sm !p-0 !m-0">
							Our best-selling brushes are <strong>BOGO 50% OFF!</strong><br />Now’s the perfect time to upgrade your
							collection.
						</p>
						<p class="font-normal italic text-center text-sm !p-0 !m-0">
							Available through August 8th at 11:59 PM MDT — while supplies last.
						</p>
						<a
							:href="route"
							aria-label="Learn more about our nonprofits link"
							class="text-sm text-white uppercase bg-black !py-3 !px-4 text-center"
						>
							Shop Brushes
						</a>
					</div>
				</template>
				<template v-slot:content-right>
					<figure role="figure" :aria-label="title">
						<img :src="brushBlitzModal" :alt="title" class="w-full object-cover max-h-[320px] md:max-h-[460px]" />
					</figure>
				</template>
			</hero-banner-modal>
			<a
				v-else-if="route"
				:href="route"
				class="inline-block text-white cursor-pointer underline text-xs/[18px]"
				:aria-label="cta"
			>
				{{ cta }}
			</a>
		</p>
	</div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import { useRewardsStore } from '@stores'

const props = defineProps({
	bannerData: {
		type: Object,
		default: null,
	},
	isCheckout: {
		type: Boolean,
		default: false,
	},
	foundationsEndpoint: {
		type: String,
		required: true,
	},
})

const rewardsStore = useRewardsStore()
const { getRewardById } = storeToRefs(rewardsStore)

const heroModal = ref(null)
const hasModal = ref(props.bannerData?.hasModal ?? false)
const id = ref(props.bannerData?.bannerId) // id that drives rewards config
const message = ref(props.bannerData?.message)
const cta = ref(props.bannerData?.cta_label)
const route = ref(props.bannerData?.cta_route)
const brushBlitzModal = ref('https://s3.us-east-2.amazonaws.com/seint.com/marketing-pages/landing/BOGO-brushes.jpg')

onMounted(async () => {
	const promises = [brushBlitzModal.value].map((url) => {
		return new Promise((resolve) => {
			const img = new Image()
			img.src = url
			img.onload = resolve
		})
	})

	await Promise.all(promises)
})

const reward = computed(() => getRewardById.value(id.value))
const autoShow = computed(() => {
	if (props.isCheckout) return false
	return props.bannerData?.autoShowModal || props.bannerData?.auto_show_info_modal
})
const title = computed(() => reward.value.modal_attributes.title)
// const description = ref(reward.value.modal_attributes.description) // not in use yet
</script>
